export const apiUrl = process.env.REACT_APP_API_URL || 'http://55.55.55.10';
export const clientId = process.env.REACT_APP_CLIENT_ID || '';
export const clientSecret = process.env.REACT_APP_CLIENT_SECRET || '';
export const clientUrl = process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000';
export const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID || '';
export const googleAppId = process.env.REACT_APP_GOOGLE_APP_ID || '';
export const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || 'hello@discode.app';
export const partnersEmail = process.env.REACT_APP_PARTNERS_EMAIL || 'partners@discode.app';
